import React, { useState, useEffect } from 'react';
import { ChevronRight, Brain, Users, Rocket, Shield, TrendingUp, Scale, Mail, Phone, User, MessageSquare, Send, Menu, X, CheckCircle, ArrowRight } from 'lucide-react';

// Team Bilder direkt importieren

import danielImg from './team/daniel.jpg';

const AINavigatorWebsite = () => {
  const [contactData, setContactData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [showImpressum, setShowImpressum] = useState(false);
  const [showDatenschutz, setShowDatenschutz] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleInputChange = (field, value) => {
    setContactData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  
    const handleSubmit = async () => {
      // Validate required fields
      if (!contactData.name || !contactData.email || !contactData.message) {
        alert('Bitte füllen Sie alle erforderlichen Felder aus.');
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(contactData.email)) {
        alert('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
        return;
      }

      setIsSubmitting(true);

      // Supabase configuration
      const SUPABASE_URL = 'https://guqtlitmqlhykuupmrqy.supabase.co';
      const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd1cXRsaXRtcWxoeWt1dXBtcnF5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgyMDMwNDcsImV4cCI6MjA3Mzc3OTA0N30.dTED93HW46M2OEMyjA3Yo_5VUEws16G8K5VQ-BTbBr0';

      try {
        const response = await fetch(`${SUPABASE_URL}/rest/v1/contacts`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': SUPABASE_ANON_KEY,
            'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
            'Prefer': 'return=minimal'
          },
          body: JSON.stringify({
            name: contactData.name,
            email: contactData.email,
            phone: contactData.phone || null,
            message: contactData.message,
            created_at: new Date().toISOString()
          })
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Supabase error:', errorText);
          throw new Error('Failed to submit');
        }
        
        console.log('Contact submission successful:', contactData);
        
        // Show success message
        setShowSuccess(true);
        
        // Reset form after 3 seconds
        setTimeout(() => {
          setContactData({ name: '', email: '', phone: '', message: '' });
          setShowSuccess(false);
        }, 3000);
      } catch (error) {
        console.error('Error submitting form:', error);
        alert('Es gab einen Fehler beim Senden. Bitte versuchen Sie es später erneut.');
      } finally {
        setIsSubmitting(false);
      }
    };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-purple-50">
      {/* Animated background elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-cyan-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000"></div>
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex justify-between items-center">
            <div className="cursor-pointer flex items-center">
              <img
                src="/logo-icon.png"
                alt="AI-Navigator Logo"
                className="h-10 w-auto"
              />
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-10">
              <a href="#services" className="text-lg text-gray-700 hover:text-purple-600 transition-colors relative group">
                Services
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-cyan-500 to-purple-600 group-hover:w-full transition-all"></span>
              </a>
              <a href="#about" className="text-lg text-gray-700 hover:text-purple-600 transition-colors relative group">
                Über uns
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-cyan-500 to-purple-600 group-hover:w-full transition-all"></span>
              </a>
              <a href="#contact" className="text-lg bg-gradient-to-r from-purple-600 to-cyan-500 text-white px-8 py-3 hover:shadow-lg transform hover:scale-105 transition-all">
                Kontakt
              </a>
            </div>

            {/* Mobile Menu Toggle */}
            <button 
              className="md:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="text-purple-600" size={28} /> : <Menu className="text-purple-600" size={28} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden mt-6 pb-4 space-y-4 border-t pt-6">
              <a href="#services" onClick={() => setIsMenuOpen(false)} className="block text-lg text-gray-700 hover:text-purple-600 transition-colors">Services</a>
              <a href="#about" onClick={() => setIsMenuOpen(false)} className="block text-lg text-gray-700 hover:text-purple-600 transition-colors">Über uns</a>
              <a href="#contact" onClick={() => setIsMenuOpen(false)} className="block text-lg text-gray-700 hover:text-purple-600 transition-colors">Kontakt</a>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="min-h-screen flex items-center justify-center px-6 py-20">
        <div className="w-full flex flex-col items-center justify-center text-center">
          <div className="mb-8 mt-[-60px]">
            <img
              src="/logo-icon.png"
              alt="AI-Navigator Logo"
              className="block mx-auto w-[162px] h-auto"
            />
          </div>
          <h1 className="text-4xl md:text-5xl font-light mb-6 leading-tight animate-fade-in-up">
            Beratung für <span className="font-bold bg-gradient-to-r from-purple-600 to-cyan-500 bg-clip-text text-transparent">ethische KI</span> und
            <br />
            <span className="font-bold bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">maßgeschneiderter KI-Agenten</span>
          </h1>
          
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto leading-relaxed">
            Wir helfen Ihnen sich im KI-Dschungel zurechtzufinden.
            Mit Fokus auf Produktivitätssteigerungen für deutsche Mittelständler.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
            <a href="#contact" className="bg-gradient-to-r from-purple-600 to-cyan-500 text-white px-8 py-4 hover:shadow-2xl transition-all transform hover:scale-105 flex items-center justify-center min-w-[200px]">
              Jetzt starten
              <ChevronRight className="ml-2 transition-transform group-hover:translate-x-1" size={20} />
            </a>
            <a href="#about" className="border-2 border-purple-600 text-purple-600 px-8 py-4 hover:bg-purple-50 transition-all flex items-center justify-center min-w-[200px]">
              Warum wir
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16 px-6 relative">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16 animate-fade-in">
            <h2 className="text-4xl md:text-5xl font-light mb-6">
              Unsere <span className="font-bold bg-gradient-to-r from-purple-600 to-cyan-500 bg-clip-text text-transparent">Services</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Von der ersten Schulung über strategische Beratung bis zur vollständigen Projektumsetzung
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Service 1 - KI-Agenten (jetzt an erster Stelle) */}
            <div
              className="group bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-2 border-2 border-transparent hover:border-purple-200"
              onMouseEnter={() => setHoveredCard(1)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="relative mb-6">
                <Rocket className="relative z-10 text-purple-600 group-hover:scale-110 transition-transform" size={40} />
              </div>
              <h3 className="text-2xl font-semibold mb-4 bg-gradient-to-r from-purple-600 to-cyan-500 bg-clip-text text-transparent">
                KI-Agenten & Implementation
              </h3>
              <p className="text-gray-600 mb-6">
                End-to-End KI-Projektlieferung mit voller Ausrichtung auf Ihre Geschäftsziele.
              </p>
              <ul className="space-y-2 text-gray-600 mb-6">
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>Standard-Agenten für Sales & Marketing</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>Individualisierte, menschenähnliche Multi-Agenten</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>Nachweis von Ergebnissen durch POCs</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>Nahtlose Integration</span>
                </li>
              </ul>
              <a href="#contact" className="inline-flex items-center text-purple-600 font-medium group-hover:gap-3 gap-1 transition-all">
                Kontakt <ArrowRight size={20} className={hoveredCard === 1 ? 'animate-bounce-x' : ''} />
              </a>
            </div>

            {/* Service 2 - Education */}
            <div
              className="group bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-2 border-2 border-transparent hover:border-cyan-200"
              onMouseEnter={() => setHoveredCard(2)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="relative mb-6">
                <Brain className="relative z-10 text-cyan-600 group-hover:scale-110 transition-transform" size={40} />
              </div>
              <h3 className="text-2xl font-semibold mb-4 bg-gradient-to-r from-cyan-500 to-purple-600 bg-clip-text text-transparent">
                Education & Management Briefings
              </h3>
              <p className="text-gray-600 mb-6">
                Stärken Sie Ihr Team mit praxisorientierten KI-Schulungsprogrammen. Maßgeschneidert für reale Anwendungen.
              </p>
              <ul className="space-y-2 text-gray-600 mb-6">
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>Gen KI Tools für den täglichen Einsatz</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>EU KI Act Zertifizierung</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>KI Bootcamp zu Industry Best Practice & ROI</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>Datenschutz und Datensicherheit</span>
                </li>
              </ul>
              <a href="#contact" className="inline-flex items-center text-cyan-600 font-medium group-hover:gap-3 gap-1 transition-all">
                Kontakt <ArrowRight size={20} className={hoveredCard === 2 ? 'animate-bounce-x' : ''} />
              </a>
            </div>

            {/* Service 3 - Beratung */}
            <div
              className="group bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-2 border-2 border-transparent hover:border-pink-200"
              onMouseEnter={() => setHoveredCard(3)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="relative mb-6">
                <Users className="relative z-10 text-pink-600 group-hover:scale-110 transition-transform" size={40} />
              </div>
              <h3 className="text-2xl font-semibold mb-4 bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
                Beratung & KI-Transformation
              </h3>
              <p className="text-gray-600 mb-6">
                Maßgeschneiderte Lösungen für Ihre Ziele. Kostenoptimierte Implementierungen mit maximaler Wirkung.
              </p>
              <ul className="space-y-2 text-gray-600 mb-6">
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>Priorisierung von ethischen KI-Lösungen</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>KI Projektrealisierung</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>KI Officer as a Service</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={16} />
                  <span>Aufbau KI-Kompetenzzentrum as a Service</span>
                </li>
              </ul>
              <a href="#contact" className="inline-flex items-center text-pink-600 font-medium group-hover:gap-3 gap-1 transition-all">
                Kontakt <ArrowRight size={20} className={hoveredCard === 3 ? 'animate-bounce-x' : ''} />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 px-6 bg-gradient-to-br from-purple-50 via-white to-cyan-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-light mb-6">
              Unsere <span className="font-bold bg-gradient-to-r from-purple-600 to-cyan-500 bg-clip-text text-transparent">Kernwerte</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ethische, wirtschaftliche und skalierbare KI-Lösungen
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-12">
            <div className="text-center group cursor-pointer animate-fade-in-up">
              <div className="mb-6 inline-block p-6 bg-gradient-to-br from-purple-100 to-purple-200 rounded-full group-hover:bg-gradient-to-br group-hover:from-purple-600 group-hover:to-purple-700 transform group-hover:scale-110 transition-all duration-300">
                <Shield size={40} className="text-purple-700 group-hover:text-white" />
              </div>
              <h3 className="text-2xl font-semibold mb-4">Ethische KI</h3>
              <p className="text-gray-600">
                Fairness, Transparenz und Rechenschaftspflicht in all unseren KI-Lösungen
              </p>
            </div>

            <div className="text-center group cursor-pointer animate-fade-in-up animation-delay-2000">
              <div className="mb-6 inline-block p-6 bg-gradient-to-br from-cyan-100 to-cyan-200 rounded-full group-hover:bg-gradient-to-br group-hover:from-cyan-600 group-hover:to-cyan-700 transform group-hover:scale-110 transition-all duration-300">
                <TrendingUp size={40} className="text-cyan-700 group-hover:text-white" />
              </div>
              <h3 className="text-2xl font-semibold mb-4">Wirtschaftliche Lösungen</h3>
              <p className="text-gray-600">
                Wir kennen den ROI – und sind bereit uns danach bezahlen zu lassen
              </p>
            </div>

            <div className="text-center group cursor-pointer animate-fade-in-up animation-delay-4000">
              <div className="mb-6 inline-block p-6 bg-gradient-to-br from-pink-100 to-pink-200 rounded-full group-hover:bg-gradient-to-br group-hover:from-pink-600 group-hover:to-pink-700 transform group-hover:scale-110 transition-all duration-300">
                <Scale size={40} className="text-pink-700 group-hover:text-white" />
              </div>
              <h3 className="text-2xl font-semibold mb-4">Skalierbare KI</h3>
              <p className="text-gray-600">
                Wir kommen vom Problem – nicht der Technologie. Fokus auf EXECUTION mit minimalem Zeitaufwand
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 px-6 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-100 via-transparent to-cyan-100 opacity-50"></div>
        <div className="max-w-6xl mx-auto relative z-10">
          <h2 className="text-4xl md:text-5xl font-light mb-12 text-center">
            Ihr <span className="font-bold bg-gradient-to-r from-purple-600 to-cyan-500 bg-clip-text text-transparent">Ansprechpartner</span>
          </h2>
          

            {/* Daniel */}
           <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all max-w-lg mx-auto">
              <div className="w-32 h-32 rounded-full mx-auto mb-4 overflow-hidden border-4 border-pink-100">
                <img 
                  src={danielImg}
                  alt="Dr. Daniel Steinberg" 
                  className="w-full h-full object-cover scale-125"
                  style={{ objectPosition: 'center 30%' }}
                />
              </div>
              <h3 className="text-2xl font-semibold text-center mb-2">Dr. Daniel Steinberg</h3>
              <p className="text-pink-600 text-center mb-4 font-medium">Gesellschafter & Evangelist</p>
              <ul className="text-gray-600 space-y-2 text-sm">
                <li>• Doktor in KI & Business Value</li>
                <li>• Erfahrung aus Kunden-, Beratungs- & Lösungsanbietersicht auf C-Level</li>
                <li>• Dozent für KI Use Cases und KI im Alltag</li>
                <li>• Thought Leadership & Strategie</li>
              </ul>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-xl font-medium text-gray-800">
              Wir lassen uns am Erfolg messen und nicht nur an unserem Zeitinvest. <a href="#contact" className="text-purple-600 hover:underline">Sprechen Sie uns an</a>
            </p>
          </div>
      </section>

      {/* Contact Section with Supabase Integration */}
      <section id="contact" className="py-20 px-6 relative">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-light mb-6">
              Lassen Sie uns <span className="font-bold bg-gradient-to-r from-purple-600 to-cyan-500 bg-clip-text text-transparent">sprechen</span>
            </h2>
            <p className="text-xl text-gray-600">
              Bereit für den nächsten Schritt? Hinterlassen Sie Ihre Kontaktdaten und wir melden uns bei Ihnen.
              Oder rufen Sie uns an unter <a href="tel:+491727005346" className="text-purple-600 hover:underline font-medium">+49 176 61644303</a>
            </p>
          </div>

          {/* Success Message */}
          {showSuccess && (
            <div className="mb-8 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 p-6 rounded-2xl flex items-center justify-center space-x-3 animate-fade-in">
              <CheckCircle className="text-green-600 animate-bounce" size={24} />
              <p className="text-green-800 font-medium">
                Vielen Dank! Wir haben Ihre Nachricht erhalten und melden uns bald bei Ihnen.
              </p>
            </div>
          )}

          <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700">
                  Name *
                </label>
                <div className="relative">
                  <User className="absolute left-3 top-3 text-purple-400" size={20} />
                  <input
                    type="text"
                    value={contactData.name}
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    className="w-full pl-12 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none transition-all"
                    placeholder="Ihr Name"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700">
                  E-Mail *
                </label>
                <div className="relative">
                  <Mail className="absolute left-3 top-3 text-purple-400" size={20} />
                  <input
                    type="email"
                    value={contactData.email}
                    onChange={(e) => handleInputChange('email', e.target.value)}
                    className="w-full pl-12 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none transition-all"
                    placeholder="ihre.email@beispiel.de"
                  />
                </div>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2 text-gray-700">
                Telefon (optional)
              </label>
              <div className="relative">
                <Phone className="absolute left-3 top-3 text-purple-400" size={20} />
                <input
                  type="tel"
                  value={contactData.phone}
                  onChange={(e) => handleInputChange('phone', e.target.value)}
                  className="w-full pl-12 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none transition-all"
                  placeholder="+49 123 456789"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2 text-gray-700">
                Nachricht *
              </label>
              <div className="relative">
                <MessageSquare className="absolute left-3 top-3 text-purple-400" size={20} />
                <textarea
                  value={contactData.message}
                  onChange={(e) => handleInputChange('message', e.target.value)}
                  rows="5"
                  className="w-full pl-12 pr-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none transition-all resize-none"
                  placeholder="Erzählen Sie uns von Ihrem Projekt oder Ihrer Herausforderung..."
                />
              </div>
            </div>

            <div className="text-center">
              <button
                onClick={handleSubmit}
                disabled={isSubmitting}
                className={`bg-gradient-to-r from-purple-600 to-cyan-500 text-white px-12 py-4 rounded-lg hover:shadow-2xl transition-all transform hover:scale-105 inline-flex items-center cursor-pointer ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                {isSubmitting ? (
                  <>
                    <span className="animate-spin mr-3">⏳</span>
                    Wird gesendet...
                  </>
                ) : (
                  <>
                    Nachricht senden
                    <Send className="ml-3" size={20} />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </section>


      {/* Footer */}
      <footer className="bg-gradient-to-br from-gray-900 to-black text-white py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-6 md:mb-0">
              <p className="text-gray-400">
                Ihr Partner für ethische KI-Lösungen
              </p>
            </div>
            
            <div className="text-center md:text-right">
              <p className="text-gray-400 mb-2">© 2025 AI-Navigator. Alle Rechte vorbehalten.</p>
              <div className="flex space-x-6 justify-center md:justify-end">
                <button 
                  onClick={() => setShowDatenschutz(true)}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                >
                  Datenschutz
                </button>
                <button 
                  onClick={() => setShowImpressum(true)}
                  className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer"
                >
                  Impressum
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Impressum Modal */}
      {showImpressum && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto p-8">
            <div className="flex justify-between items-start mb-6">
              <h2 className="text-3xl font-bold">Impressum</h2>
              <button 
                onClick={() => setShowImpressum(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <X size={24} />
              </button>
            </div>
            
            <div className="space-y-6 text-gray-700">
              <div>
                <h3 className="font-semibold text-lg mb-2">Angaben gemäß § 5 TMG</h3>
                <p>AI-Navigator</p>
                <p>Brachvogelweg 23</p>
                <p>40468 Düsseldorf</p>
                <p className="mt-2">Gesellschafter:</p>
                <ul className="ml-4">
                  <li>Daniel Steinberg</li>
                </ul>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">Kontakt</h3>
                <p>E-Mail: daniel@ai-navigator.io</p>
                <p>Telefon: +49 176 61644303</p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
                <p>Daniel Steinberg</p>
                <p>Brachvogelweg 23<br />40468 Düsseldorf</p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">EU-Streitschlichtung</h3>
                <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline ml-1">
                  https://ec.europa.eu/consumers/odr/
                </a></p>
                <p>Unsere E-Mail-Adressen finden Sie oben im Impressum.</p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">Verbraucherstreitbeilegung/Universalschlichtungsstelle</h3>
                <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">Haftungsausschluss</h3>
                <h4 className="font-semibold mt-3">Haftung für Inhalte</h4>
                <p className="text-sm">Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
                
                <h4 className="font-semibold mt-3">Haftung für Links</h4>
                <p className="text-sm">Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>
                
                <h4 className="font-semibold mt-3">Urheberrecht</h4>
                <p className="text-sm">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Datenschutz Modal */}
      {showDatenschutz && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto p-8">
            <div className="flex justify-between items-start mb-6">
              <h2 className="text-3xl font-bold">Datenschutzerklärung</h2>
              <button 
                onClick={() => setShowDatenschutz(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <X size={24} />
              </button>
            </div>
            
            <div className="space-y-6 text-gray-700">
              <div>
                <h3 className="font-semibold text-lg mb-2">1. Datenschutz auf einen Blick</h3>
                <h4 className="font-semibold mt-3">Allgemeine Hinweise</h4>
                <p className="text-sm">Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">2. Allgemeine Hinweise und Pflichtinformationen</h3>
                <h4 className="font-semibold mt-3">Datenschutz</h4>
                <p className="text-sm">Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>
                
                <h4 className="font-semibold mt-3">Verantwortliche Stelle</h4>
                <p className="text-sm">AI-Navigator<br/>
                Daniel Steinberg<br/>
                E-Mail: daniel@ai-navigator.io</p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">3. Datenerfassung auf dieser Website</h3>
                <h4 className="font-semibold mt-3">Cookies</h4>
                <p className="text-sm">Diese Website verwendet nur technisch notwendige Cookies. Diese Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren.</p>
                
                <h4 className="font-semibold mt-3">Kontaktformular</h4>
                <p className="text-sm">Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
                
                <h4 className="font-semibold mt-3">Speicherung der Daten</h4>
                <p className="text-sm">Die von Ihnen im Kontaktformular eingegebenen Daten werden über Supabase verarbeitet und gespeichert. Supabase ist ein Datenbank-Service, der die sichere Speicherung Ihrer Kontaktanfragen ermöglicht.</p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">4. Ihre Rechte</h3>
                <h4 className="font-semibold mt-3">Auskunft, Löschung und Berichtigung</h4>
                <p className="text-sm">Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten.</p>
                
                <h4 className="font-semibold mt-3">Recht auf Einschränkung der Verarbeitung</h4>
                <p className="text-sm">Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.</p>
                
                <h4 className="font-semibold mt-3">Widerspruchsrecht</h4>
                <p className="text-sm">Sie haben das Recht, jederzeit gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einzulegen.</p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">5. Hosting</h3>
                <h4 className="font-semibold mt-3">Externes Hosting</h4>
                <p className="text-sm">Diese Website wird bei Vercel gehostet. Der Anbieter ist Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA.</p>
                <p className="text-sm mt-2">Beim Besuch unserer Website erfasst Vercel verschiedene Logfiles inklusive Ihrer IP-Adressen. Details entnehmen Sie der Datenschutzerklärung von Vercel: 
                <a href="https://vercel.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:underline ml-1">
                  https://vercel.com/legal/privacy-policy
                </a></p>
              </div>

              <div>
                <h3 className="font-semibold text-lg mb-2">6. Aktualität und Änderung dieser Datenschutzerklärung</h3>
                <p className="text-sm">Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Dezember 2024. Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Custom CSS for animations */}
    </div>
  );
};

export default AINavigatorWebsite;